import { PhForkKnife } from '@phosphor-icons/vue'

import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import {
  type WebsiteResource,
  type TopPicksSectionCreate,
  type TopPicksSection,
  type TopPicksSectionUpdate,
} from '../../WebsiteBuilder.types'
import { websiteBlockMethods } from '../common/methods'

import { createTopPicksData } from './methods/createTopPicksData'
import PopularItemsPreview from './preview/PopularItemsPreview.vue'
const i18n = i18nPlugin.global

export const TopPicksBlockModule: BuilderBlockModule<
  TopPicksSection,
  TopPicksSectionCreate,
  TopPicksSectionUpdate,
  WebsiteResource
> = {
  createData: createTopPicksData,
  meta: [
    {
      icon: PhForkKnife,
      key: 'top-picks',
      label: i18n.t('website-builder.blocks.top-picks'),
      sort: 2,
    },
  ],
  methods: websiteBlockMethods,
  preview: PopularItemsPreview,
}
